import React, { useEffect, memo, Fragment, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import Scrollbar from "smooth-scrollbar";
// import Logo from "../../components/logo";
import logo from "../../../../assets/images/coyote-logo.jpg";
import VerticalNav from "../SidebarStyle/vertical-nav";

// Import selectors & action from setting store
import * as SettingSelector from "../../../../store/setting/selectors";
import { Image } from "react-bootstrap";

const Sidebar = memo((props) => {
  const [decodedToken, setDecodedToken] = useState();
  const sidebarRef = useRef(null);
  const token = localStorage.getItem("coyote-token");
  const sidebarColor = useSelector(SettingSelector.sidebar_color);
  const sidebarHide = useSelector(SettingSelector.sidebar_show); // array
  const sidebarType = useSelector(SettingSelector.sidebar_type); // array
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);
  
  const minisidebar = () => {
    document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
  };
  
  useEffect(() => {
    Scrollbar.init(document.querySelector("#my-scrollbar"));

    window.addEventListener("resize", () => {
      const tabs = document.querySelectorAll(".nav");
      const sidebarResponsive = document.querySelector(
        '[data-sidebar="responsive"]'
      );
      if (window.innerWidth < 1025) {
        Array.from(tabs, (elem) => {
          if (
            !elem.classList.contains("flex-column") &&
            elem.classList.contains("nav-tabs") &&
            elem.classList.contains("nav-pills")
          ) {
            elem.classList.add("flex-column", "on-resize");
          }
          return elem.classList.add("flex-column", "on-resize");
        });
        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains("sidebar-mini")) {
            sidebarResponsive.classList.add("sidebar-mini", "on-resize");
          }
        }
      } else {
        Array.from(tabs, (elem) => {
          if (elem.classList.contains("on-resize")) {
            elem.classList.remove("flex-column", "on-resize");
          }
          return elem.classList.remove("flex-column", "on-resize");
        });
        if (sidebarResponsive !== null) {
          if (
            sidebarResponsive.classList.contains("sidebar-mini") &&
            sidebarResponsive.classList.contains("on-resize")
          ) {
            sidebarResponsive.classList.remove("sidebar-mini", "on-resize");
          }
        }
      }
    });
  });

  useEffect(() => {
    const handleOutsideClick = (e) => {
      const sidebarEl = sidebarRef.current;
      const sidebarDom = document.querySelector('[data-sidebar="responsive"]');

      const isClickInsideSidebar = sidebarEl && sidebarEl.contains(e.target);
      
      // React-select ke different class names check karo
      const isClickInsideReactSelect = 
        e.target.closest(".select__menu") ||           // menu dropdown
        e.target.closest(".select__control") ||        // input control
        e.target.closest(".select__menu-list") ||      // menu list
        e.target.closest(".select__option") ||         // individual options
        e.target.closest(".select__dropdown-indicator") || // dropdown arrow
        e.target.closest(".select__clear-indicator") ||    // clear button
        e.target.closest(".select__multi-value") ||        // multi-select values
        e.target.closest(".select__input") ||              // input field
        e.target.closest(".select__placeholder") ||        // placeholder
        e.target.closest(".select__single-value") ||       // selected value
        e.target.closest(".select__indicators") ||         // indicators container
        e.target.closest("[class*='select__']") ||         // any class starting with select__
        e.target.closest("[id*='react-select']") ||        // react-select IDs
        e.target.closest(".css-") ||                       // CSS-in-JS classes (react-select uses emotion)
        e.target.classList.contains("select__menu") ||     // direct class check
        e.target.classList.contains("select__option");     // direct option check

      // Only close if click is outside sidebar and react-select
      if (
        !isClickInsideSidebar &&
        !isClickInsideReactSelect &&
        window.innerWidth < 1025
      ) {
        if (sidebarDom && !sidebarDom.classList.contains("sidebar-mini")) {
          sidebarDom.classList.add("sidebar-mini");
        }
      }
    };

    // Use 'mousedown' for better performance and to catch events before onClick
    document.addEventListener("mousedown", handleOutsideClick);
    
    // Also add 'touchstart' for mobile devices
    document.addEventListener("touchstart", handleOutsideClick);
    
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  const decodeToken = (token) => {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  };
  
  useEffect(() => {
    setDecodedToken(decodeToken(token)?.user);
  }, [token]);

  return (
    <Fragment>
      <aside
        ref={sidebarRef}
        className={` ${sidebarColor} ${sidebarType.join(
          " "
        )} ${sidebarMenuStyle} ${
          sidebarHide.join(" ") ? "sidebar-none" : "sidebar"
        }   sidebar-base  `}
        data-sidebar="responsive"
      >
        <div className="sidebar-header d-flex align-items-center justify-content-start">
          <Link to="/dashboard" className="navbar-brand">
            {/* <Logo /> */}
            <Image
              src={logo}
              className="logo-title"
              style={{ width: "100%", height: "30px" }}
              alt="coyote-logo"
            />
            {/* <h4 className="logo-title">
              {
                props.app_name}
            </h4> */}
          </Link>
          <div
            className="sidebar-toggle"
            data-toggle="sidebar"
            data-active="true"
            onClick={minisidebar}
          >
            <i className="icon" style={{ transform: "rotate(360deg)" }}>
              <svg
                width="20"
                className="icon-20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 12.2744L19.25 12.2744"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </i>
          </div>
        </div>
        <div
          className="pt-0 sidebar-body data-scrollbar"
          data-scroll="1"
          id="my-scrollbar"
        >
          {/* sidebar-list class to be added after replace css */}
          <div className="sidebar-list navbar-collapse" id="sidebar">
            <VerticalNav />
          </div>
        </div>
        <div className="sidebar-footer"></div>
      </aside>
    </Fragment>
  );
});

export default Sidebar;